import {
  call,
  takeLatest,
  put,
} from 'redux-saga/effects';
import { createTheme } from 'mineral-ui/themes';
import { updateTheme } from '../theme';
import { THEME_FETCH } from '../actionTypes';
import api from '../../utils/services';

function* getTheme(action) {
  const data = yield call(api.theme, action.carrierId);
  if (data.length > 0) {
    const { value } = data[0];
    const theme = JSON.parse(value);
    yield put(updateTheme(theme));
  } else { // Default to the default blue theme;
    const blueTheme = createTheme({
      colors: {
        theme: 'blue',
      },
    });
    yield put(updateTheme(blueTheme));
  }
}

export default function* themeInfoSaga() {
  yield takeLatest(THEME_FETCH, getTheme);
}
